import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const SubheaderText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '14px',
  color: theme.palette.text.primary,
  lineHeight: 'normal',
  marginBottom: '5px',
}))

export const Text = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: theme.palette.text.primary,
  margin: 0,
}))

export const HeaderText = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '18.2px',
  color: theme.palette.text.primary,
  margin: 0,
}))

export const HeaderTextFlex = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '18.2px',
  color: theme.palette.text.primary,
  margin: 0,
  flex: 1,
}))

export const FlexRowBetweenBox = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 24, // 3 * 8px (theme spacing)
})
